import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Constants from '../../utils/Constants';
import DownloadButton from './DownloadButton';

CashLimitConfirmationFileDownloadButton.propTypes = {
    confirmationFileId: PropTypes.number,
};

function CashLimitConfirmationFileDownloadButton(props) {
    const {
        confirmationFileId = null,
    } = props;
    const { t } = useTranslation();
    const downloadData = {
        id: confirmationFileId,
    };
    const downloadErrorMessageKeys = {
        unauthorized: 'cash-limit-confirmation-file-download.download-failed-unauthorized',
        failed: 'cash-limit-confirmation-file-download.download-failed',
    };
    return (
        <DownloadButton
            urlPath={Constants.DOWNLOAD_CASH_LIMIT_CONFIRMATION_FILE_PATH}
            data={downloadData}
            errorMessageKeys={downloadErrorMessageKeys}
            disabled={!confirmationFileId}
            label={t('cash-limit-confirmation-file-download.download')}
            className="cash-limit-confirmation-file-download-button"
        />
    );
}

export default CashLimitConfirmationFileDownloadButton;
